import React from 'react'

import { Button } from '../../../../components/button'
import { ETFHoldingsDialogType, ETFHoldingsStandardResponse } from '../types'

interface ITableFooter {
  ticker: string
  data: ETFHoldingsStandardResponse
  handleDialogToggle: (value?: ETFHoldingsDialogType) => void
  type: string
}

export function TableFooter({ ticker, data, handleDialogToggle, type }: ITableFooter) {
  const isPremium = FinvizSettings.hasUserPremium

  return (
    <div className="absolute bottom-0 mt-auto flex h-7 w-full items-center justify-start bg-gray-50 px-3 text-2xs dark:bg-gray-700">
      <div className="pr-1.5 text-muted">{`${data.etfHoldingsTotal} Holding${
        data.etfHoldingsTotal > 1 ? 's' : ''
      } Total`}</div>
      {data.etfHoldingsTotal > 10 && (
        <>
          <div className="min-h-1 min-w-1 rounded-full bg-gray-100 dark:bg-gray-600" />
          <Button
            theme="transparent"
            size="small"
            onClick={() => handleDialogToggle(ETFHoldingsDialogType.Table)}
            className="tab-link flex cursor-pointer items-center text-link hover:underline"
            leftContent={!isPremium ? 'lock' : undefined}
            data-testid={`etf-holdings-${type}-btn-show-all`}
          >
            Show All
          </Button>
        </>
      )}
      <div className="min-h-1 min-w-1 rounded-full bg-gray-100 dark:bg-gray-600" />
      <Button
        theme="transparent"
        as={isPremium ? 'a' : undefined}
        size="small"
        href={isPremium ? `/screener.ashx?f=etf_heldby_${ticker}&ft=5` : undefined}
        onClick={isPremium ? undefined : () => handleDialogToggle(ETFHoldingsDialogType.Table)}
        className="tab-link flex cursor-pointer items-center text-link hover:underline"
        leftContent={!isPremium ? 'lock' : undefined}
        data-testid={`etf-holdings-${type}-btn-open-in-screener`}
      >
        Open in Screener
      </Button>
    </div>
  )
}
